import { Injectable } from '@angular/core';
import { HttpClientService } from '@core/services/http-client/http-client.service';
import { RecipientListInterface } from '@feature/dashboard/recipients/types/recipient-list';
import { SenderListInterface } from '@feature/dashboard/senders/types/sender-list';
import { API_URL_CONSTANT } from '@sharedModule/constants/api-url.constant';
import { DataGrid } from '@sharedModule/models/data-grid.model';
import { ResponseIdentity } from '@sharedModule/models/server-response-identity.model';
import { removeEmptyStrings } from '@sharedModule/utils/form.utils';
import { Observable } from 'rxjs';
import { TransactionListInterface } from '../types/transaction-list';
import {
  TransactionListFilter,
  defaultTransactionListFilter,
} from '../types/transaction-list-filter';
import {
  CreateTransactionInterface,
  TransactionChargesInterface,
  TransactionChargesResponseInterface,
} from '../types/create-transaction';
import { UpdatePayoutStatusInterface } from '../types/update-payout-status';

@Injectable({
  providedIn: 'root',
})
export class TransactionService {
  constructor(private httpClient: HttpClientService) {}

  getTransactionList(
    payload: TransactionListFilter = defaultTransactionListFilter
  ): Observable<ResponseIdentity<DataGrid<TransactionListInterface[]>>> {
    return this.httpClient.post(
      API_URL_CONSTANT.transaction.getTransactionList,
      removeEmptyStrings(payload)
    );
  }

  getTransactionDetails(payload: {
    id: string;
    partner_id?: number;
  }): Observable<ResponseIdentity<TransactionListInterface>> {
    return this.httpClient.post(
      API_URL_CONSTANT.transaction.getTransactionDetails,
      payload
    );
  }

  getSenderList(payload: {
    sender_country: string;
  }): Observable<ResponseIdentity<SenderListInterface[]>> {
    return this.httpClient.post(API_URL_CONSTANT.sender.getSenderList, payload);
  }

  getRecipientList(payload: {
    beneficiary_country: string;
  }): Observable<ResponseIdentity<RecipientListInterface[]>> {
    return this.httpClient.post(
      API_URL_CONSTANT.recipient.getRecipientList,
      payload
    );
  }

  updateTransactionStatus(payload: {
    transaction_status: string;
    reason: string;
    amount_paid: string;
    trans_session_id: string;
  }): Observable<ResponseIdentity<null>> {
    return this.httpClient.post(
      API_URL_CONSTANT.transaction.updateTransactionStatus,
      payload
    );
  }

  updatePayoutStatus(
    payload: UpdatePayoutStatusInterface
  ): Observable<ResponseIdentity<null>> {
    return this.httpClient.post(
      API_URL_CONSTANT.transaction.updatePayoutStatus,
      payload
    );
  }

  getTransactionCharges(
    payload: TransactionChargesInterface
  ): Observable<ResponseIdentity<TransactionChargesResponseInterface>> {
    return this.httpClient.post(
      API_URL_CONSTANT.transaction.getTransactionCharges,
      payload
    );
  }

  createTransaction(
    payload: CreateTransactionInterface
  ): Observable<ResponseIdentity<null>> {
    return this.httpClient.post(
      API_URL_CONSTANT.transaction.createTransaction,
      payload
    );
  }
}
